var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.908,
    x2: 404.712,
    xlinkHref: "#lg1",
    y1: 110.952,
    y2: 397.756
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.442,
    x2: 259.282,
    y1: 58.326,
    y2: 178.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 373.738,
    y2: 443.766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0268b4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.753,
    x2: 99.42,
    xlinkHref: "#lg2",
    y1: 112.036,
    y2: 54.37
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.756,
    x2: 216.423,
    xlinkHref: "#lg2",
    y1: 112.036,
    y2: 54.37
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.785,
    x2: 333.451,
    xlinkHref: "#lg2",
    y1: 112.036,
    y2: 54.37
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.764,
    x2: 445.554,
    xlinkHref: "#lg2",
    y1: 110.834,
    y2: 56.355
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.577,
    x2: 119.481,
    xlinkHref: "#lg3",
    y1: 64.545,
    y2: 64.545
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.577,
    x2: 236.481,
    xlinkHref: "#lg3",
    y1: 64.545,
    y2: 64.545
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.577,
    x2: 353.481,
    xlinkHref: "#lg3",
    y1: 64.545,
    y2: 64.545
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.577,
    x2: 470.481,
    xlinkHref: "#lg3",
    y1: 64.545,
    y2: 64.545
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ebac5"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.5,
    x2: 79.5,
    xlinkHref: "#lg4",
    y1: 180.46,
    y2: 241.048
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.5,
    x2: 196.5,
    xlinkHref: "#lg4",
    y1: 180.46,
    y2: 241.048
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5,
    x2: 313.5,
    xlinkHref: "#lg4",
    y1: 180.46,
    y2: 241.048
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.5,
    x2: 430.5,
    xlinkHref: "#lg4",
    y1: 180.46,
    y2: 241.048
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.5,
    x2: 79.5,
    xlinkHref: "#lg4",
    y1: 264.128,
    y2: 324.716
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.5,
    x2: 196.5,
    xlinkHref: "#lg4",
    y1: 264.128,
    y2: 324.716
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5,
    x2: 313.5,
    xlinkHref: "#lg4",
    y1: 264.128,
    y2: 324.716
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.5,
    x2: 430.5,
    xlinkHref: "#lg4",
    y1: 264.128,
    y2: 324.716
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.5,
    x2: 79.5,
    xlinkHref: "#lg4",
    y1: 347.797,
    y2: 408.385
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.5,
    x2: 196.5,
    xlinkHref: "#lg4",
    y1: 347.797,
    y2: 408.385
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5,
    x2: 313.5,
    xlinkHref: "#lg4",
    y1: 347.797,
    y2: 408.385
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.5,
    x2: 430.5,
    xlinkHref: "#lg4",
    y1: 347.797,
    y2: 408.385
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.368,
    x2: 357.676,
    y1: 532.676,
    y2: 379.984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0329,
    stopColor: "#c8e2e6",
    stopOpacity: 0.033
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#91b4c0",
    stopOpacity: 0.684
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.912,
    x2: 415.879,
    xlinkHref: "#lg3",
    y1: 347.289,
    y2: 444.256
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-1 0 0 -1 -336.667 1862)",
    gradientUnits: "userSpaceOnUse",
    x1: -740.809,
    x2: -653.114,
    xlinkHref: "#lg3",
    y1: 1429.481,
    y2: 1517.176
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.333,
    x2: 419.722,
    xlinkHref: "#lg1",
    y1: 342.71,
    y2: 448.099
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.334,
    x2: 419.724,
    y1: 342.706,
    y2: 448.096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -481.421 410.246)",
    gradientUnits: "userSpaceOnUse",
    x1: 597.443,
    x2: 625.02,
    xlinkHref: "#lg5",
    y1: 554.472,
    y2: 554.472
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.878,
    x2: 377.455,
    xlinkHref: "#lg5",
    y1: 349.324,
    y2: 349.324
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.857,
    x2: 371.611,
    xlinkHref: "#lg3",
    y1: 385.234,
    y2: 399.988
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m490.59 64.044h-471.18c-10.72 0-19.41 8.69-19.41 19.41v329.18c0 10.72 8.69 19.41 19.41 19.41h471.18c10.72 0 19.41-8.69 19.41-19.41v-329.18c0-10.72-8.69-19.41-19.41-19.41zm-60.09 15.62c13.07 0 23.67 10.59 23.67 23.66s-10.6 23.67-23.67 23.67-23.67-10.6-23.67-23.67 10.6-23.66 23.67-23.66zm-117 0c13.07 0 23.67 10.59 23.67 23.66s-10.6 23.67-23.67 23.67-23.67-10.6-23.67-23.67 10.6-23.66 23.67-23.66zm-117 0c13.07 0 23.67 10.59 23.67 23.66s-10.6 23.67-23.67 23.67-23.67-10.6-23.67-23.67 10.6-23.66 23.67-23.66zm-117 0c1.81 0 3.56.2 5.25.59 10.54 2.38 18.42 11.8 18.42 23.07s-7.88 20.7-18.42 23.08c-1.69.39-3.44.59-5.25.59-13.07 0-23.67-10.6-23.67-23.67s10.6-23.66 23.67-23.66z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.59 64.044h-471.18c-10.72 0-19.41 8.69-19.41 19.41v59.16h510v-59.16c0-10.72-8.69-19.41-19.41-19.41zm-405.84 62.36c-1.69.39-3.44.59-5.25.59-13.07 0-23.67-10.6-23.67-23.67s10.6-23.66 23.67-23.66c1.81 0 3.56.2 5.25.59 10.54 2.38 18.42 11.8 18.42 23.07s-7.88 20.7-18.42 23.08zm111.75.59c-13.07 0-23.67-10.6-23.67-23.67s10.6-23.66 23.67-23.66 23.67 10.59 23.67 23.66-10.6 23.67-23.67 23.67zm117 0c-13.07 0-23.67-10.6-23.67-23.67s10.6-23.66 23.67-23.66 23.67 10.59 23.67 23.66-10.6 23.67-23.67 23.67zm117 0c-13.07 0-23.67-10.6-23.67-23.67s10.6-23.66 23.67-23.66 23.67 10.59 23.67 23.66-10.6 23.67-23.67 23.67z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 342.536v70.099c0 10.721 8.691 19.412 19.412 19.412h471.176c10.721 0 19.412-8.691 19.412-19.412v-70.099z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m176.32 142.614h-91.57v-16.21c10.54-2.38 18.42-11.81 18.42-23.08s-7.88-20.69-18.42-23.07v-16.21h13z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.323 142.614h-91.57v-16.21c10.54-2.38 18.42-11.81 18.42-23.08s-7.88-20.69-18.42-23.07v-16.21h13z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.351 142.614h-91.57v-16.21c10.54-2.38 18.42-11.81 18.42-23.08s-7.88-20.69-18.42-23.07v-16.21h13z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510 125.234v17.38h-74.19v-16.21c.59-.13 1.17-.29 1.73-.47 9.66-2.97 16.69-11.97 16.69-22.61s-7.03-19.64-16.69-22.6c-.56-.18-1.14-.34-1.73-.47v-16.21h13z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.5 115.713c-10.931 0-19.792-8.861-19.792-19.792v-62.752c0-10.931 8.861-19.792 19.792-19.792 10.931 0 19.792 8.861 19.792 19.792v62.752c0 10.931-8.861 19.792-19.792 19.792z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.5 115.713c-10.931 0-19.792-8.861-19.792-19.792v-62.752c0-10.931 8.861-19.792 19.792-19.792 10.931 0 19.792 8.861 19.792 19.792v62.752c0 10.931-8.861 19.792-19.792 19.792z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.5 115.713c-10.931 0-19.792-8.861-19.792-19.792v-62.752c0-10.931 8.861-19.792 19.792-19.792 10.931 0 19.792 8.861 19.792 19.792v62.752c0 10.931-8.861 19.792-19.792 19.792z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.5 115.713c-10.931 0-19.792-8.861-19.792-19.792v-62.752c0-10.931 8.861-19.792 19.792-19.792 10.931 0 19.792 8.861 19.792 19.792v62.752c0 10.931-8.861 19.792-19.792 19.792z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m98.5 233.044h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.5 233.044h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.5 233.044h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.5 233.044h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m98.5 316.713h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.5 316.713h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.5 316.713h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.5 316.713h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m98.5 400.381h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.5 400.381h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.5 400.381h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.5 400.381h-38c-9.389 0-17-7.611-17-17v-32c0-9.389 7.611-17 17-17h38c9.389 0 17 7.611 17 17v32c0 9.389-7.611 17-17 17z",
    fill: "url(#SVGID_23_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m510 412.634v-21.98l-67.384-67.384c-19.132-21.073-46.745-34.305-77.449-34.305-57.757 0-104.579 46.822-104.579 104.579 0 13.596 2.599 26.584 7.32 38.5h222.682c10.72 0 19.41-8.69 19.41-19.41z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 363.667,
    cy: 392.044,
    fill: "url(#SVGID_25_)",
    r: 104.579
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.667,
    cy: 392.044,
    fill: "url(#SVGID_26_)",
    r: 94.579
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.667,
    cy: 392.044,
    fill: "url(#SVGID_27_)",
    r: 87.106
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.774 392.045c0 48.103-38.997 87.1-87.11 87.1-48.103 0-87.1-38.997-87.1-87.1 0-24.052 9.754-45.832 25.511-61.599l61.589 61.599v-87.11c48.114 0 87.11 38.996 87.11 87.11z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m363.667 341.337c-4.541 0-8.223-3.681-8.223-8.223v-10.279c0-4.541 3.681-8.223 8.223-8.223 4.541 0 8.223 3.681 8.223 8.223v10.279c-.001 4.541-3.682 8.223-8.223 8.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.667 469.475c-4.541 0-8.223-3.681-8.223-8.223v-10.278c0-4.541 3.681-8.223 8.223-8.223 4.541 0 8.223 3.681 8.223 8.223v10.278c-.001 4.541-3.682 8.223-8.223 8.223z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m414.374 392.044c0-4.541 3.681-8.223 8.223-8.223h10.278c4.541 0 8.223 3.681 8.223 8.223 0 4.541-3.681 8.223-8.223 8.223h-10.278c-4.542 0-8.223-3.682-8.223-8.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.236 392.044c0-4.541 3.681-8.223 8.223-8.223h10.278c4.541 0 8.223 3.681 8.223 8.223 0 4.541-3.681 8.223-8.223 8.223h-10.278c-4.542 0-8.223-3.682-8.223-8.223z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m321.518 352.092 3.997 19.514c.449 2.194 3.159 3.008 4.743 1.424l1.969-1.969 23.496 23.496c1.057 1.057 2.771 1.057 3.828 0l7.75-7.75c1.057-1.057 1.057-2.771 0-3.828l-23.496-23.496 1.969-1.969c1.584-1.584.77-4.293-1.424-4.743l-19.514-3.997c-1.976-.406-3.723 1.342-3.318 3.318z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.32 308.844-10.972 16.624c-1.234 1.869.107 4.361 2.347 4.361h2.785v58.532c0 1.495 1.212 2.707 2.707 2.707h10.961c1.495 0 2.707-1.212 2.707-2.707v-58.532h2.785c2.24 0 3.581-2.491 2.347-4.361l-10.972-16.624c-1.113-1.684-3.584-1.684-4.695 0z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.667,
    cy: 392.044,
    fill: "url(#SVGID_31_)",
    r: 15.912
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.1567f8efc713b5dd468ed246e2d143e5.svg";
export { ForwardRef as ReactComponent };